var _a;
var _w = window;
_w._current_culture = "";
var culture = (_a = _w._culture) !== null && _a !== void 0 ? _a : {
    info: { thousandSep: ",", decimalSep: ".", dateFormat: "yy-mm-dd", numberFormat: "#,0.####" },
    /**
     * sets a culture
     * @param c  culture as string for example 'de' or 'en-us'
     */
    set: function (c) {
        var cult_vals = culture.cultures[c.toLowerCase()];
        if (cult_vals === undefined)
            throw "unknown culture '" + c + "'";
        culture.info.decimalSep = cult_vals[0];
        culture.info.thousandSep = cult_vals[1];
        culture.info.dateFormat = cult_vals[2];
        _w.current_culture = c;
    },
    /**
     * returns current culture
     */
    get: function () {
        return _w.current_culture;
    },
    cultures: {
        //         'ar':['.',',','dd/mm/y'],
        // 'bg':[',',' ','d.m.yy \'г.\''],
        // 'ca':[',','.','dd/mm/yy'],
        // 'zh-hans':['.',',','yy/m/d'],
        // 'cs':[',',' ','d.m.yy'],
        // 'da':[',','.','dd-mm-yy'],
        'de': [',', '.', 'dd.mm.yy'],
        // 'el':[',','.','d/m/yy'],
        // 'es':[',','.','dd/mm/yy'],
        // 'fi':[',',' ','d.m.yy'],
        // 'fr':[',',' ','dd/mm/yy'],
        // 'he':['.',',','dd/mm/yy'],
        // 'hu':[',',' ','yy.mm.dd.'],
        // 'is':[',','.','d.m.yy'],
        // 'it':[',','.','dd/mm/yy'],
        // 'ja':['.',',','yy/mm/dd'],
        // 'ko':['.',',','yy-mm-dd'],
        // 'nl':[',','.','d-m-yy'],
        // 'no':[',',' ','dd.mm.yy'],
        // 'pl':[',',' ','yy-mm-dd'],
        // 'pt':[',','.','dd/mm/yy'],
        // 'rm':['.','\'','dd/mm/yy'],
        // 'ro':[',','.','dd.mm.yy'],
        // 'ru':[',',' ','dd.mm.yy'],
        // 'hr':[',','.','d.m.yy.'],
        // 'sk':[',',' ','d. m. yy'],
        // 'sq':[',','.','yy-mm-dd'],
        // 'sv':[',',' ','yy-mm-dd'],
        // 'th':['.',',','d/m/yy'],
        // 'tr':[',','.','dd.mm.yy'],
        // 'ur':['.',',','dd/mm/yy'],
        // 'id':[',','.','dd/mm/yy'],
        // 'uk':[',',' ','dd.mm.yy'],
        // 'be':[',',' ','dd.mm.yy'],
        // 'sl':[',','.','d.m.yy'],
        // 'et':[',',' ','d.mm.yy'],
        // 'lv':[',',' ','yy.mm.dd.'],
        // 'lt':[',','.','yy.mm.dd'],
        // 'tg':[',',' ','dd.mm.y'],
        // 'fa':['.',',','mm/dd/yy'],
        // 'vi':[',','.','dd/mm/yy'],
        // 'hy':['.',',','dd.mm.yy'],
        // 'az':[',',' ','dd.mm.yy'],
        // 'eu':[',','.','yy/mm/dd'],
        // 'hsb':[',','.','d. m. yy'],
        // 'mk':[',','.','dd.mm.yy'],
        // 'tn':['.',',','yy/mm/dd'],
        // 'xh':['.',',','yy/mm/dd'],
        // 'zu':['.',',','yy/mm/dd'],
        // 'af':['.',',','yy/mm/dd'],
        // 'ka':[',',' ','dd.mm.yy'],
        // 'fo':[',','.','dd-mm-yy'],
        // 'hi':['.',',','dd-mm-yy'],
        // 'mt':['.',',','dd/mm/yy'],
        // 'se':[',',' ','dd.mm.yy'],
        // 'ga':['.',',','dd/mm/yy'],
        // 'ms':['.',',','dd/mm/yy'],
        // 'kk':[',',' ','dd.mm.yy'],
        // 'ky':[',',' ','dd.mm.y'],
        // 'sw':['.',',','m/d/yy'],
        // 'tk':[',',' ','dd.mm.y'],
        // 'uz':[',',' ','dd/mm yy'],
        // 'tt':[',',' ','dd.mm.yy'],
        // 'bn':['.',',','dd-mm-y'],
        // 'pa':['.',',','dd-mm-y'],
        // 'gu':['.',',','dd-mm-y'],
        // 'or':['.',',','dd-mm-y'],
        // 'ta':['.',',','dd-mm-yy'],
        // 'te':['.',',','dd-mm-y'],
        // 'kn':['.',',','dd-mm-y'],
        // 'ml':['.',',','dd-mm-y'],
        // 'as':['.',',','dd-mm-yy'],
        // 'mr':['.',',','dd-mm-yy'],
        // 'sa':['.',',','dd-mm-yy'],
        // 'mn':[',',' ','y.mm.dd'],
        // 'bo':['.',',','yy/m/d'],
        // 'cy':['.',',','dd/mm/yy'],
        // 'km':['.',',','yy-mm-dd'],
        // 'lo':['.',',','dd/mm/yy'],
        // 'gl':[',','.','dd/mm/yy'],
        // 'kok':['.',',','dd-mm-yy'],
        // 'syr':['.',',','dd/mm/yy'],
        // 'si':['.',',','yy-mm-dd'],
        // 'iu':['.',',','d/mm/yy'],
        // 'am':['.',',','d/m/yy'],
        // 'tzm':[',','.','dd-mm-yy'],
        // 'ne':['.',',','m/d/yy'],
        // 'fy':[',','.','d-m-yy'],
        // 'ps':[',','،','dd/mm/y'],
        // 'fil':['.',',','m/d/yy'],
        // 'dv':['.',',','dd/mm/y'],
        // 'ha':['.',',','d/m/yy'],
        // 'yo':['.',',','d/m/yy'],
        // 'quz':[',','.','dd/mm/yy'],
        // 'nso':['.',',','yy/mm/dd'],
        // 'ba':[',',' ','dd.mm.y'],
        // 'lb':[',',' ','dd/mm/yy'],
        // 'kl':[',','.','dd-mm-yy'],
        // 'ig':['.',',','d/m/yy'],
        // 'ii':['.',',','yy/m/d'],
        // 'arn':[',','.','dd-mm-yy'],
        // 'moh':['.',',','m/d/yy'],
        // 'br':[',',' ','dd/mm/yy'],
        // 'ug':['.',',','yy-m-d'],
        // 'mi':['.',',','dd/mm/yy'],
        // 'oc':[',',' ','dd/mm/yy'],
        // 'co':[',',' ','dd/mm/yy'],
        // 'gsw':[',',' ','dd/mm/yy'],
        // 'sah':[',',' ','mm.dd.yy'],
        // 'qut':['.',',','dd/mm/yy'],
        // 'rw':[',',' ','m/d/yy'],
        // 'wo':[',',' ','dd/mm/yy'],
        // 'prs':[',','.','dd/mm/y'],
        // 'gd':['.',',','dd/mm/yy'],
        // 'ar-sa':['.',',','dd/mm/y'],
        // 'bg-bg':[',',' ','d.m.yy \'г.\''],
        // 'ca-es':[',','.','dd/mm/yy'],
        // 'zh-tw':['.',',','yy/m/d'],
        // 'cs-cz':[',',' ','d.m.yy'],
        // 'da-dk':[',','.','dd-mm-yy'],
        'de-de': [',', '.', 'dd.mm.yy'],
        // 'el-gr':[',','.','d/m/yy'],
        'en-us': ['.', ',', 'm/d/yy'],
        // 'fi-fi':[',',' ','d.m.yy'],
        // 'fr-fr':[',',' ','dd/mm/yy'],
        // 'he-il':['.',',','dd/mm/yy'],
        // 'hu-hu':[',',' ','yy.mm.dd.'],
        // 'is-is':[',','.','d.m.yy'],
        // 'it-it':[',','.','dd/mm/yy'],
        // 'ja-jp':['.',',','yy/mm/dd'],
        // 'ko-kr':['.',',','yy-mm-dd'],
        // 'nl-nl':[',','.','d-m-yy'],
        // 'nb-no':[',',' ','dd.mm.yy'],
        // 'pl-pl':[',',' ','yy-mm-dd'],
        // 'pt-br':[',','.','dd/mm/yy'],
        // 'rm-ch':['.','\'','dd/mm/yy'],
        // 'ro-ro':[',','.','dd.mm.yy'],
        // 'ru-ru':[',',' ','dd.mm.yy'],
        // 'hr-hr':[',','.','d.m.yy.'],
        // 'sk-sk':[',',' ','d. m. yy'],
        // 'sq-al':[',','.','yy-mm-dd'],
        // 'sv-se':[',',' ','yy-mm-dd'],
        // 'th-th':['.',',','d/m/yy'],
        // 'tr-tr':[',','.','dd.mm.yy'],
        // 'ur-pk':['.',',','dd/mm/yy'],
        // 'id-id':[',','.','dd/mm/yy'],
        // 'uk-ua':[',',' ','dd.mm.yy'],
        // 'be-by':[',',' ','dd.mm.yy'],
        // 'sl-si':[',','.','d.m.yy'],
        // 'et-ee':[',',' ','d.mm.yy'],
        // 'lv-lv':[',',' ','yy.mm.dd.'],
        // 'lt-lt':[',','.','yy.mm.dd'],
        // 'tg-cyrl-tj':[',',' ','dd.mm.y'],
        // 'fa-ir':['.',',','mm/dd/yy'],
        // 'vi-vn':[',','.','dd/mm/yy'],
        // 'hy-am':['.',',','dd.mm.yy'],
        // 'az-latn-az':[',',' ','dd.mm.yy'],
        // 'eu-es':[',','.','yy/mm/dd'],
        // 'hsb-de':[',','.','d. m. yy'],
        // 'mk-mk':[',','.','dd.mm.yy'],
        // 'tn-za':['.',',','yy/mm/dd'],
        // 'xh-za':['.',',','yy/mm/dd'],
        // 'zu-za':['.',',','yy/mm/dd'],
        // 'af-za':['.',',','yy/mm/dd'],
        // 'ka-ge':[',',' ','dd.mm.yy'],
        // 'fo-fo':[',','.','dd-mm-yy'],
        // 'hi-in':['.',',','dd-mm-yy'],
        // 'mt-mt':['.',',','dd/mm/yy'],
        // 'se-no':[',',' ','dd.mm.yy'],
        // 'ms-my':['.',',','dd/mm/yy'],
        // 'kk-kz':[',',' ','dd.mm.yy'],
        // 'ky-kg':[',',' ','dd.mm.y'],
        // 'sw-ke':['.',',','m/d/yy'],
        // 'tk-tm':[',',' ','dd.mm.y'],
        // 'uz-latn-uz':[',',' ','dd/mm yy'],
        // 'tt-ru':[',',' ','dd.mm.yy'],
        // 'bn-in':['.',',','dd-mm-y'],
        // 'pa-in':['.',',','dd-mm-y'],
        // 'gu-in':['.',',','dd-mm-y'],
        // 'or-in':['.',',','dd-mm-y'],
        // 'ta-in':['.',',','dd-mm-yy'],
        // 'te-in':['.',',','dd-mm-y'],
        // 'kn-in':['.',',','dd-mm-y'],
        // 'ml-in':['.',',','dd-mm-y'],
        // 'as-in':['.',',','dd-mm-yy'],
        // 'mr-in':['.',',','dd-mm-yy'],
        // 'sa-in':['.',',','dd-mm-yy'],
        // 'mn-mn':[',',' ','y.mm.dd'],
        // 'bo-cn':['.',',','yy/m/d'],
        // 'cy-gb':['.',',','dd/mm/yy'],
        // 'km-kh':['.',',','yy-mm-dd'],
        // 'lo-la':['.',',','dd/mm/yy'],
        // 'gl-es':[',','.','dd/mm/yy'],
        // 'kok-in':['.',',','dd-mm-yy'],
        // 'syr-sy':['.',',','dd/mm/yy'],
        // 'si-lk':['.',',','yy-mm-dd'],
        // 'iu-cans-ca':['.',',','d/m/yy'],
        // 'am-et':['.',',','d/m/yy'],
        // 'ne-np':['.',',','m/d/yy'],
        // 'fy-nl':[',','.','d-m-yy'],
        // 'ps-af':[',','،','dd/mm/y'],
        // 'fil-ph':['.',',','m/d/yy'],
        // 'dv-mv':['.',',','dd/mm/y'],
        // 'ha-latn-ng':['.',',','d/m/yy'],
        // 'yo-ng':['.',',','d/m/yy'],
        // 'quz-bo':[',','.','dd/mm/yy'],
        // 'nso-za':['.',',','yy/mm/dd'],
        // 'ba-ru':[',',' ','dd.mm.y'],
        // 'lb-lu':[',',' ','dd/mm/yy'],
        // 'kl-gl':[',','.','dd-mm-yy'],
        // 'ig-ng':['.',',','d/m/yy'],
        // 'ii-cn':['.',',','yy/m/d'],
        // 'arn-cl':[',','.','dd-mm-yy'],
        // 'moh-ca':['.',',','m/d/yy'],
        // 'br-fr':[',',' ','dd/mm/yy'],
        // 'ug-cn':['.',',','yy-m-d'],
        // 'mi-nz':['.',',','dd/mm/yy'],
        // 'oc-fr':[',',' ','dd/mm/yy'],
        // 'co-fr':[',',' ','dd/mm/yy'],
        // 'gsw-fr':[',',' ','dd/mm/yy'],
        // 'sah-ru':[',',' ','mm.dd.yy'],
        // 'qut-gt':['.',',','dd/mm/yy'],
        // 'rw-rw':[',',' ','m/d/yy'],
        // 'wo-sn':[',',' ','dd/mm/yy'],
        // 'prs-af':[',','.','dd/mm/y'],
        // 'gd-gb':['.',',','dd/mm/yy'],
        // 'ar-iq':['.',',','dd/mm/yy'],
        // 'zh-cn':['.',',','yy/m/d'],
        // 'de-ch':['.','\'','dd.mm.yy'],
        'en-gb': ['.', ',', 'dd/mm/yy'],
        // 'es-mx':['.',',','dd/mm/yy'],
        // 'fr-be':[',','.','d/mm/yy'],
        // 'it-ch':['.','\'','dd.mm.yy'],
        // 'nl-be':[',','.','d/mm/yy'],
        // 'nn-no':[',',' ','dd.mm.yy'],
        // 'pt-pt':[',','.','dd-mm-yy'],
        // 'sr-latn-cs':[',','.','d.m.yy'],
        // 'sv-fi':[',',' ','d.m.yy'],
        // 'az-cyrl-az':[',',' ','dd.mm.yy'],
        // 'dsb-de':[',','.','d. m. yy'],
        // 'se-se':[',',' ','yy-mm-dd'],
        // 'ga-ie':['.',',','dd/mm/yy'],
        // 'ms-bn':[',','.','dd/mm/yy'],
        // 'uz-cyrl-uz':[',',' ','dd.mm.yy'],
        // 'bn-bd':['.',',','dd-mm-y'],
        // 'mn-mong-cn':['.',',','yy/m/d'],
        // 'iu-latn-ca':['.',',','d/mm/yy'],
        // 'tzm-latn-dz':[',','.','dd-mm-yy'],
        // 'quz-ec':[',','.','dd/mm/yy'],
        // 'ar-eg':['.',',','dd/mm/yy'],
        // 'zh-hk':['.',',','d/m/yy'],
        // 'de-at':[',','.','dd.mm.yy'],
        // 'en-au':['.',',','d/mm/yy'],
        // 'es-es':[',','.','dd/mm/yy'],
        // 'fr-ca':[',',' ','yy-mm-dd'],
        // 'sr-cyrl-cs':[',','.','d.m.yy'],
        // 'se-fi':[',',' ','d.m.yy'],
        // 'quz-pe':['.',',','dd/mm/yy'],
        // 'ar-ly':['.',',','dd/mm/yy'],
        // 'zh-sg':['.',',','d/m/yy'],
        // 'de-lu':[',','.','dd.mm.yy'],
        // 'en-ca':['.',',','dd/mm/yy'],
        // 'es-gt':['.',',','dd/mm/yy'],
        // 'fr-ch':['.','\'','dd.mm.yy'],
        // 'hr-ba':[',','.','d.m.yy.'],
        // 'smj-no':[',',' ','dd.mm.yy'],
        // 'ar-dz':['.',',','dd-mm-yy'],
        // 'zh-mo':['.',',','d/m/yy'],
        // 'de-li':['.','\'','dd.mm.yy'],
        // 'en-nz':['.',',','d/mm/yy'],
        // 'es-cr':[',','.','dd/mm/yy'],
        // 'fr-lu':[',',' ','dd/mm/yy'],
        // 'bs-latn-ba':[',','.','d.m.yy'],
        // 'smj-se':[',',' ','yy-mm-dd'],
        // 'ar-ma':['.',',','dd-mm-yy'],
        // 'en-ie':['.',',','dd/mm/yy'],
        // 'es-pa':['.',',','mm/dd/yy'],
        // 'fr-mc':[',',' ','dd/mm/yy'],
        // 'sr-latn-ba':[',','.','d.m.yy'],
        // 'sma-no':[',',' ','dd.mm.yy'],
        // 'ar-tn':['.',',','dd-mm-yy'],
        // 'en-za':['.',' ','yy/mm/dd'],
        // 'es-do':['.',',','dd/mm/yy'],
        // 'sr-cyrl-ba':[',','.','d.m.yy'],
        // 'sma-se':[',',' ','yy-mm-dd'],
        // 'ar-om':['.',',','dd/mm/yy'],
        // 'en-jm':['.',',','dd/mm/yy'],
        // 'es-ve':[',','.','dd/mm/yy'],
        // 'bs-cyrl-ba':[',','.','d.m.yy'],
        // 'sms-fi':[',',' ','d.m.yy'],
        // 'ar-ye':['.',',','dd/mm/yy'],
        // 'en-029':['.',',','mm/dd/yy'],
        // 'es-co':[',','.','dd/mm/yy'],
        // 'sr-latn-rs':[',','.','d.m.yy'],
        // 'smn-fi':[',',' ','d.m.yy'],
        // 'ar-sy':['.',',','dd/mm/yy'],
        // 'en-bz':['.',',','dd/mm/yy'],
        // 'es-pe':['.',',','dd/mm/yy'],
        // 'sr-cyrl-rs':[',','.','d.m.yy'],
        // 'ar-jo':['.',',','dd/mm/yy'],
        // 'en-tt':['.',',','dd/mm/yy'],
        // 'es-ar':[',','.','dd/mm/yy'],
        // 'sr-latn-me':[',','.','d.m.yy'],
        // 'ar-lb':['.',',','dd/mm/yy'],
        // 'en-zw':['.',',','m/d/yy'],
        // 'es-ec':[',','.','dd/mm/yy'],
        // 'sr-cyrl-me':[',','.','d.m.yy'],
        // 'ar-kw':['.',',','dd/mm/yy'],
        // 'en-ph':['.',',','m/d/yy'],
        // 'es-cl':[',','.','dd-mm-yy'],
        // 'ar-ae':['.',',','dd/mm/yy'],
        // 'es-uy':[',','.','dd/mm/yy'],
        // 'ar-bh':['.',',','dd/mm/yy'],
        // 'es-py':[',','.','dd/mm/yy'],
        // 'ar-qa':['.',',','dd/mm/yy'],
        // 'en-in':['.',',','dd-mm-yy'],
        // 'es-bo':[',','.','dd/mm/yy'],
        // 'en-my':['.',',','d/m/yy'],
        // 'es-sv':['.',',','dd/mm/yy'],
        // 'en-sg':['.',',','d/m/yy'],
        // 'es-hn':['.',',','dd/mm/yy'],
        // 'es-ni':['.',',','dd/mm/yy'],
        // 'es-pr':['.',',','dd/mm/yy'],
        // 'es-us':['.',',','m/d/yy'],
        // 'bs-cyrl':[',','.','d.m.yy'],
        // 'bs-latn':[',','.','d.m.yy'],
        // 'sr-cyrl':[',','.','d.m.yy'],
        // 'sr-latn':[',','.','d.m.yy'],
        // 'smn':[',',' ','d.m.yy'],
        // 'az-cyrl':[',',' ','dd.mm.yy'],
        // 'sms':[',',' ','d.m.yy'],
        // 'zh':['.',',','yy/m/d'],
        // 'nn':[',',' ','dd.mm.yy'],
        // 'bs':[',','.','d.m.yy'],
        // 'az-latn':[',',' ','dd.mm.yy'],
        // 'sma':[',',' ','yy-mm-dd'],
        // 'uz-cyrl':[',',' ','dd.mm.yy'],
        // 'mn-cyrl':[',',' ','y.mm.dd'],
        // 'iu-cans':['.',',','d/m/yy'],
        // 'zh-hant':['.',',','d/m/yy'],
        // 'nb':[',',' ','dd.mm.yy'],
        // 'sr':[',','.','d.m.yy'],
        // 'tg-cyrl':[',',' ','dd.mm.y'],
        // 'dsb':[',','.','d. m. yy'],
        // 'smj':[',',' ','yy-mm-dd'],
        // 'uz-latn':[',',' ','dd/mm yy'],
        // 'mn-mong':['.',',','yy/m/d'],
        // 'iu-latn':['.',',','d/mm/yy'],
        // 'tzm-latn':[',','.','dd-mm-yy'],
        // 'ha-latn':['.',',','d/m/yy'],
        // 'zh-chs':['.',',','yy/m/d'],
        // 'zh-cht':['.',',','d/m/yy'],
        '': ['.', ',', 'yy-mm-dd']
    }
};
_w._culture = culture;
/**
 * culture info for date and number formatting and parsing
 */
export default culture;
